<div class="row" (click)='collapse()' [ngStyle]="{'cursor': !isEditable?'pointer':''}" *ngIf="!isAdd && !loadingError">
    <div class='col-sm-1'>{{session.id}}</div>
    <div class='col-sm-11'>
        <div class="pull-right" *ngIf="!isEditable">
            <div class='inline' style='margin-left:0.5em;' *ngIf="session.integrations.zoom">
                <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
            </div>
            <div class='inline' style='margin-left:0.5em;' *ngIf="session.integrations.docebo">
                <app-open-button-sm (click)="openDocebo()">Docebo</app-open-button-sm>
            </div>
            <div class='inline' style='margin-left:0.5em;' *ngIf="session.joinUrl">
                <app-open-button-sm (click)="open(session.joinUrl)">Join</app-open-button-sm>
            </div>
        </div>
        {{session.name}} 
        <div style='font-size:0.9em;margin-top:0.25em;'>
            <div>{{session.startDate}}</div>
            <div>{{session.status.name}}</div>
        </div>
    </div>
</div>

<div class='row' *ngIf='loadingError'>
    <div class='col-sm-12 text-center error'>
        <div>{{loadingError}}</div>
    </div>
</div>

<div class="row" [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div class="col-sm-12" *ngIf='isLoaded' [ngStyle]="{'margin-top': !isAdd ? '2.0em' : '0'}" style='padding-bottom:1.0em;'>
        <form [formGroup]="form" (ngSubmit)="save()" novalidate>

            <div class="col-sm-12 instructions">
                <div class='pull-right action-menu-sm'>
                    <app-button-status *ngIf="isSaving || isDeleting"></app-button-status>
                    <app-edit-button-sm (click)='edit()' *ngIf="!isEditable"></app-edit-button-sm>
                    <app-save-button-sm (click)='save()' *ngIf="isEditable"></app-save-button-sm>
                    <app-cancel-button-sm (click)='cancel()' *ngIf="isEditable"></app-cancel-button-sm>
                </div>
                <div *ngIf="!isAdd">Below are details specific to this Session.</div>
                <div *ngIf="isAdd">Complete the form below to create a Session.</div>
            </div>

            <div class='col-sm-12 text-center error' *ngIf='errorMessage'>
                {{errorMessage}}
            </div>

            <div class="col-sm-12">
                <label>
                    Name *
                    <span *ngIf="name.invalid && (name.dirty || name.touched || isSubmitted)" class="error">
                        <span *ngIf="name.errors.required">- Required</span>
                        <span *ngIf="name.errors.maxlength">- Too long</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( session.name ) ? session.name : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="name" formControlName="name" placeholder="Name" required class="form-control" maxlength="300">
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>
                    Start Date *
                    <span *ngIf="startDate.invalid && (startDate.dirty || startDate.touched || isSubmitted)" class="error">
                        <span *ngIf="startDate.errors.required">- Required</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{ ( session.startDate ) ? session.startDate : "-" }}</div>
                <div *ngIf="isEditable">
                    <div id="startDate" formControlName="startDate" class="input-group" a2e-datetimepicker [options]="a2eOptions">
                        <input class="form-control" />
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-calendar"></span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>End Date</label>
                <div *ngIf="!isEditable">{{ ( session.endDate ) ? session.endDate : "-" }}</div>
                <div *ngIf="isEditable">
                    <div id="endDate" formControlName="endDate" class="input-group" a2e-datetimepicker [options]="a2eOptions">
                        <input class="form-control" />
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-calendar"></span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>Check In Date</label>
                <div *ngIf="!isEditable">{{ ( session.checkInDate ) ? session.checkInDate : "-" }}</div>
                <div *ngIf="isEditable">
                    <div id="checkInDate" formControlName="checkInDate" class="input-group" a2e-datetimepicker [options]="a2eOptions">
                        <input class="form-control" />
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-calendar"></span>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>Min Attendance</label>
                <div *ngIf="!isEditable">{{ ( session.minAttendance !== null ) ? session.minAttendance : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="minAttendance" formControlName="minAttendance" class="form-control" type="number" min = "0" placeholder="Max Attendance">
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>Max Attendance</label>
                <div *ngIf="!isEditable">{{ ( session.maxAttendance !== null ) ? session.maxAttendance : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="maxAttendance" formControlName="maxAttendance" class="form-control" type="number" min = "0" placeholder="Max Attendance">
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>Sort Order</label>
                <div *ngIf="!isEditable">{{ ( session.sortOrder !== null ) ? session.sortOrder : "-" }}</div>
                <div *ngIf="isEditable">
                    <input id="sortOrder" formControlName="sortOrder" class="form-control" type="number" min = "0" placeholder="Sort Order">
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>Required</label>
                <div *ngIf="!isEditable">{{session.required ? "Yes" : "No"}}</div>
                <div *ngIf="isEditable">
                    <ng-select id="required" formControlName="required" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Required" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>
                    Status *
                    <span *ngIf="isEditable && status.invalid && (status.dirty || status.touched || isSubmitted)" class="error">
                        <span *ngIf="status.errors.required">- Required</span>
                    </span>
                </label>
                <div *ngIf="!isEditable">{{session.status && session.status.name?session.status.name:"-"}}</div>
                <div *ngIf="isEditable">
                    <ng-select id="status" formControlName="status" [items]="statuses" bindValue="id" bindLabel="name" placeholder="Select Status" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 col-lg-3">
                <label>
                    Delivery Method
                    <app-display-box>
                        The delivery_method field represents how the instructional content is "delivered", and can have the following values:
                        <ul>
                            <li>Classroom: in classroom, live person in proximity</li>
                            <li>Online: on computer, interactive instruction</li>
                            <li>Healthstream Online: on computer, from healthstream catalog (defunct?)</li>
                            <li>Videoconference: in classroom, instruction via VC</li>
                            <li>Other: Streaming Media: on computer, passive instruction</li>
                        </ul>
                    </app-display-box>
                </label>
                <div *ngIf="!isEditable">{{session.deliveryMethod && session.deliveryMethod.name?session.deliveryMethod.name:"-"}}</div>
                <div *ngIf="isEditable">
                    <ng-select id="deliveryMethod" formControlName="deliveryMethod" [items]="deliveryMethods" bindValue="id" bindLabel="name" placeholder="Select Delivery Method" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Description
                    <span *ngIf="isEditable && description.invalid && (description.dirty || description.touched || isSubmitted)" class="error">
                        <span *ngIf="description.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 4,000 characters</div>
                </label>
                <div *ngIf="!isEditable">{{ session.description ? session.description : "-" }}</div>
                <div *ngIf="isEditable">
                    <textarea id="description" formControlName="description" placeholder="Description" rows="10" class="form-control" maxlength="4000"></textarea>
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Topic Keywords
                    <span *ngIf="isEditable && topicKeywords.invalid && (topicKeywords.dirty || topicKeywords.touched || isSubmitted)" class="error">
                        <span *ngIf="topicKeywords.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 120 characters</div>
                </label>
                <div *ngIf="!isEditable">{{session.topicKeywords?session.topicKeywords:"-"}}</div>
                <div *ngIf="isEditable">
                    <input id="topicKeywords" formControlName="topicKeywords" class="form-control" placeholder="Topic Keywords" maxlength='120'>
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Private URL
                    <span *ngIf="isEditable && privateUrl.invalid && (privateUrl.dirty || privateUrl.touched || isSubmitted)" class="error">
                        <span *ngIf="privateUrl.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 200 characters</div>
                </label>
                <div *ngIf="!isEditable">{{session.privateUrl?session.privateUrl:"-"}}</div>
                <div *ngIf="isEditable">
                    <input id="privateUrl" formControlName="privateUrl" class="form-control" placeholder="Private URL" maxlength='200'>
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    EEDS AIN
                    <span *ngIf="isEditable && eedsAin.invalid && (eedsAin.dirty || eedsAin.touched || isSubmitted)" class="error">
                        <span *ngIf="eedsAin.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 9 characters</div>
                </label>
                <div *ngIf="!isEditable">{{session.eedsAin?session.eedsAin:"-"}}</div>
                <div *ngIf="isEditable">
                    <input id="eedsAin" formControlName="eedsAin" class="form-control" placeholder="EEDS AIN" maxlength='9'>
                </div>
            </div>

            <!-- 
            <div class="groupTitle">Handouts</div>

            <div>
                <label>File</label>
                <div *ngIf="!isEditable">{{ ( session.handout_name ) ? session.handout_name : "-" }}</div>
                <div *ngIf="!isEditable">{{session.session_name}} (pdf)</div>
                <div *ngIf="isEditable">
                    <input class="form-control" [(ngModel)]='editData.handout_file' type="file" placeholder="File"
                        name="handout_file">
                </div>
            </div>
            -->

            <div class="col-sm-12">
                <div class='group-title' style='margin-top:2.0em;'>
                    Learning Management System Integrations
                </div>
            </div>
            
            <div class="col-sm-12">
                <label>
                    Docebo Integration
                </label>
                <div *ngIf="!isEditable">
                    <div class='pull-right' *ngIf="session.integrations.docebo">
                        <app-open-button-sm (click)="openDocebo()">Docebo</app-open-button-sm>
                    </div>
                    <div>{{session.integrations.docebo ? "Yes" : "No"}}</div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="docebo" formControlName="docebo" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Docebo Integration" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12" *ngIf="docebo.value">
                <label>
                    Show Open Button to Enrollees
                </label>
                <div *ngIf="!isEditable">
                    <div >
                        {{session.integrations.docebo && session.integrations.docebo.showOpen ? "Yes" : "No"}}
                    </div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="doceboShowOpen" formControlName="doceboShowOpen" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Show Open Button" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <!-- 
            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Video Conference Integrations</div>
            </div>

            <div class="col-sm-12">
                <label>
                    Zoom Integration
                </label>
                <div *ngIf="!isEditable">
                    <div class='pull-right' *ngIf="session.integrations.zoom">
                        <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
                    </div>
                    <div>{{session.integrations.zoom ? "Yes" : "No"}}</div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="zoom" formControlName="zoom" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Zoom Integration" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12" *ngIf="zoom.value">
                <label>
                    Show Open Button to Enrollees
                </label>
                <div *ngIf="!isEditable">
                    <div>
                        {{session.integrations.zoom && session.integrations.zoom.showOpen ? "Yes" : "No"}}
                    </div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="zoomShowOpen" formControlName="zoomShowOpen" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Show Open Button" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div> 
            -->
            
            <div class="col-sm-12">
                <div class="group-title" style='margin-top:2.0em;'>Landing Page</div>
            </div>

            <div class="col-sm-12">
                <label>
                    Status
                    <span *ngIf="isEditable && landingPage.invalid && (landingPage.dirty || landingPage.touched || submitted)" class="error">
                        <span *ngIf="landingPage.errors.required">- Required</span>
                    </span>
                    <!-- <div class='details' *ngIf="isEditable"></div> -->
                </label>
                <div *ngIf="!isEditable">
                    <div>{{session.landingPage ? "Yes" : "No"}}</div>
                    <div style='margin-top:1.0em;'>
                        <app-open-button-sm (click)='open(course.landingPageUrl)' [ngClass]="{'hide':isEditable}">View Landing Page Preview <span *ngIf="!course.landingPage">(Inactive)</span></app-open-button-sm>
                    </div>
                </div>
                <div *ngIf="isEditable">
                    <ng-select id="landingPage" formControlName="landingPage" [items]="yesNo" bindValue="value" bindLabel="name" placeholder="Select Landing Page Status" [clearable]="false" [searchable]="false"></ng-select>
                </div>
            </div>

            <div class="col-sm-12">
                <label>
                    Custom Join Link URL
                    <span *ngIf="isEditable && joinUrl.invalid && (joinUrl.dirty || joinUrl.touched || isSubmitted)" class="error">
                        <span *ngIf="joinUrl.errors.maxlength">- Too long</span>
                    </span>
                    <div class='details' *ngIf="isEditable">Maxlength: 400 characters</div>
                </label>
                <div *ngIf="!isEditable">
                    <span *ngIf="session.joinUrl">
                        <a [attr.href]="session.joinUrl" target="_blank">{{session.joinUrl}}</a>
                    </span>
                    <span *ngIf="!session.joinUrl">-</span>
                </div>
                <div *ngIf="isEditable">
                    <input id="joinUrl" formControlName="joinUrl" class="form-control" placeholder="URL" maxlength='400'>
                </div>
            </div>

        </form>
    </div>
</div>